import { XMarkIcon } from '@heroicons/react/20/solid'
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {addCartItem} from "../../modules/checkoutHelpers";
import {sendSlackMessageTracked} from "../../models/notifications";

export default function PromotionalBanner({shouldShowPremium}) {
    const [isOpen, setIsOpen] = useState(true)
    const navigate = useNavigate()

    return (
        <div>
            {
                isOpen &&
                    <div className="flex items-center gap-x-6 bg-gray-900 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 cursor-pointer"
                         onClick={() => {
                             navigate("/cart")
                             // Sets the cart data
                             let cartObject = {
                                 productIndex: 1,
                                 frequency: "month",
                                 quantity: 1,
                             }
                             addCartItem(cartObject)

                             sendSlackMessageTracked("Visitor clicked on main banner.")
                         }}
                    >
                        <p className="text-sm text-white w-full flex justify-center items-center">

                            {
                                Boolean(shouldShowPremium) &&
                                <div>
                                    <strong className="font-semibold">Go Premium</strong> &nbsp;<span
                                    aria-hidden="true">&rarr;</span>
                                </div>
                            }


                            {
                                !Boolean(shouldShowPremium) &&
                                <div>
                                    <strong className="font-semibold">Going Pro</strong>
                                    <svg viewBox="0 0 2 2" aria-hidden="true"
                                         className="h-4 w-4 mx-2 inline size-0.5 fill-current">
                                        <circle r={1} cx={1} cy={1}/>
                                    </svg>
                                    Start your first 12 months now &nbsp;<span
                                    aria-hidden="true">&rarr;</span>
                                </div>
                            }

                        </p>
                        {/*<div className="flex flex-1 justify-end">*/}
                        {/*    <button type="button" className="-m-3 p-3 focus-visible:outline-offset-[-4px]" onClick={() => setIsOpen(false)}>*/}
                        {/*        <span className="sr-only">Dismiss</span>*/}
                        {/*        <XMarkIcon aria-hidden="true" className="size-5 text-white"/>*/}
                        {/*    </button>*/}
                        {/*</div>*/}
                    </div>
            }
        </div>
    )
}
